var __TEMP__ = require('./_baseAssignValue.js');var baseAssignValue = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./eq.js');var eq = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = assignMergeValue;
